// Small presentational atoms shared by every inventory section
// (SectionHeader, TeamBadge, StatusPill, SortHeader).

import React from "react";
import { ArrowUp, ArrowDown, ChevronsUpDown, Check, X, CalendarClock } from "lucide-react";
import { NAVY, TEAL, AMBER } from "./constants";
import { teamLabel } from "./seed";

export function SectionHeader({ eyebrow, title, subtitle, right }) {
  return (
    <div className="flex items-end justify-between gap-4 flex-wrap mb-4">
      <div>
        <p className="text-[11px] uppercase tracking-[0.14em] font-semibold text-slate-500 mb-1">{eyebrow}</p>
        <h2 className="text-xl sm:text-2xl font-semibold tracking-tight" style={{ color: NAVY }}>{title}</h2>
        {subtitle && <p className="text-sm text-slate-600 mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function TeamBadge({ team }) {
  return (
    <span className="inline-flex items-center h-6 px-2 rounded-md text-xs font-semibold whitespace-nowrap" style={{ background: `${NAVY}12`, color: NAVY }}>
      {teamLabel(team)}
    </span>
  );
}

export function StatusPill({ status }) {
  const style = status === "approved"
    ? { bg: `${TEAL}14`,  fg: TEAL,           border: `${TEAL}55`  }
    : status === "denied"
      ? { bg: "#FEE2E2",  fg: "#B91C1C",      border: "#FCA5A5"    }
      : { bg: `${AMBER}1A`, fg: "#B45309",   border: `${AMBER}55` };
  // Approved supply requests read as "Ready for pick up" in the UI so
  // outreach staff immediately know their supplies are waiting at HQ.
  const label = status === "approved" ? "Ready for pick up" : status;
  return (
    <span className="inline-flex items-center gap-1 h-6 px-2 rounded-md text-xs font-semibold border whitespace-nowrap" style={{ background: style.bg, color: style.fg, borderColor: style.border }}>
      {status === "approved" ? <Check className="h-3 w-3" /> : status === "denied" ? <X className="h-3 w-3" /> : <CalendarClock className="h-3 w-3" />}
      {label}
    </span>
  );
}

// Sortable column header — click to toggle asc / desc.
export function SortHeader({ label, col, sortBy, onClick }) {
  const active = sortBy?.col === col;
  const Icon = !active ? ChevronsUpDown : sortBy.dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`sort-${col}-btn`}
      className={`inline-flex items-center gap-1 select-none transition ${active ? "text-slate-800" : "text-slate-500 hover:text-slate-700"}`}
    >
      <span>{label}</span>
      <Icon className={`h-3 w-3 ${active ? "opacity-100" : "opacity-40"}`} />
    </button>
  );
}
